<template>
  <ElementLayout>
    <!-- @vue-ignore -->
    <template #element>
      <div class="d-flex align-center mb-2">
        <!-- @vue-ignore -->
        <span v-html="customLabel"></span>
        <!-- @vue-ignore -->
        <v-tooltip :text="$t('common.buttons.downloadFile')" location="top left">
          <template v-slot:activator="{ props }">
            <!-- @vue-ignore -->
            <v-btn
              v-bind="props"
              variant="text"
              size="small"
              density="compact"
              icon="mdi-tray-arrow-down"
              class="ml-2"
              :disabled="!toUploadFile"
              @click="downloadFile(toUploadFile)"
            ></v-btn>
          </template>
        </v-tooltip>
      </div>
      <!-- @vue-ignore -->
      <v-btn
        v-if="files.length === 0"
        color="grey-lighten-3"
        class="text-medium-emphasis font-weight-regular"
        rounded="md"
        @click="clickBtn"
      ><!-- @vue-ignore -->{{ $t('common.buttons.selectFile') }}</v-btn>
      <div v-else class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <img
            width="40"
            src="https://static.vecteezy.com/system/resources/previews/036/027/410/non_2x/document-icon-in-trendy-outline-style-isolated-on-white-background-document-silhouette-symbol-for-your-website-design-logo-app-ui-illustration-eps10-free-vector.jpg"
            alt="icon"
          >
          <!-- @vue-ignore -->
          <span v-html="files[0].name" class="ml-3"></span>
        </div>
        <!-- @vue-ignore -->
        <v-btn
          size="x-small"
          density="comfortable"
          icon="mdi-close"
          color="grey-lighten-3"
          class="text-medium-emphasis"
          flat
          @click="() => files = []"
        ></v-btn>
      </div>
      <!-- @vue-ignore -->
      <v-file-input
        v-model="files"
        ref="fileInput"
        style="display: none;"
        @update:model-value="() => update(files[0])"
      ></v-file-input>
    </template>
  </ElementLayout>
</template>

<script lang="ts">
import { defineElement } from '@vueform/vueform'
import { downloadFile } from '@/utils/cloud_file_services';

interface Props {
  label: string
  name: string
}
interface Element {
  value: null | File,
  update: Function
}
interface Context {
  element: Element
  attrs: {
    toUploadFile?: string
  }
}

export default defineElement({
  name: 'CustomFileToCompleteElement',
  setup(props: Props, { element, attrs }: Context) {
    const { label, name } = props
    const { value, update } = element
    const { toUploadFile } = attrs

    return {
      toUploadFile,
      value,
      update,
      name,
      label: "",
      customLabel: label,
      downloadFile
    }
  },
  data() {
    return {
      files: [] as File[]
    }
  },
  methods: {
    clickBtn() {
      // @ts-ignore
      this.$refs.fileInput!.click()
    },
  },
  watch: {
    files(newVal: File[]) {
      // @ts-ignore
      this.update(newVal[0])
    }
  }
})
</script>
